import React, { useState, useEffect, useContext } from 'react';
import axiosInstance from '../axiosConfig';
import { AuthContext } from '../AuthContext';

function InventoryForm({ onClose, onInventoryCreated, loadOpenInventories }) {
    const { selectedServiceCenter, projects } = useContext(AuthContext);
    const [selectedProject, setSelectedProject] = useState(null);
    const [showCompleted, setShowCompleted] = useState(false);
    const [completedInventories, setCompletedInventories] = useState([]);
    const [selectedInventory, setSelectedInventory] = useState(null);
    const [inventoryDetails, setInventoryDetails] = useState(null);

    useEffect(() => {
        if (projects.length > 0) {
            setSelectedProject(projects[0].id);
        }
    }, [projects]);

    const handleFormSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('project', selectedProject);
        formData.append('service_center', selectedServiceCenter.id);

        axiosInstance.post('/api/create_inventory/', formData)
            .then(response => {
                if (response.data && response.data.open_inventories_html) {
                    onInventoryCreated(response.data.open_inventories_html[0].id); 
                    loadOpenInventories(); // Вызов обновления списка открытых инвентаризаций
                    window.Toastify({
                        text: "Инвентаризация успешно создана.",
                        duration: 3000,
                        gravity: "top",
                        position: "right",
                        backgroundColor: "linear-gradient(to right, #00b09b, #96c93d)",
                        stopOnFocus: true,
                        className: 'custom-toast',
                    }).showToast();
                    onClose();
                } else {
                    throw new Error('Response does not contain expected data');
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 400 && error.response.data.message) {
                    window.Toastify({
                        text: error.response.data.message,
                        duration: 3000,
                        gravity: "top",
                        position: "right",
                        backgroundColor: "linear-gradient(to right, #dc3545, #f46b6b)",
                        stopOnFocus: true,
                        className: 'custom-toast',
                    }).showToast();
                } else {
                    console.error('Error creating inventory:', error);
                    window.Toastify({
                        text: "Ошибка при создании инвентаризации.",
                        duration: 3000,
                        gravity: "top",
                        position: "right",
                        backgroundColor: "linear-gradient(to right, #dc3545, #f46b6b)",
                        stopOnFocus: true,
                        className: 'custom-toast',
                    }).showToast();
                }
            });
    };

    useEffect(() => {
        if (showCompleted && completedInventories.length === 0) {
            axiosInstance.get('/api/completed_inventories/')
                .then(response => {
                    setCompletedInventories(response.data.inventories);
                })
                .catch(error => {
                    console.error('Error fetching completed inventories:', error);
                });
        }
    }, [showCompleted, completedInventories.length]);

    const handleShowCompleted = () => {
        setShowCompleted(!showCompleted);
    };

    const handleInventoryClick = (inventoryId) => {
        const inventory = completedInventories.find(inv => inv.id === inventoryId);
        if (inventory) {
            setInventoryDetails(inventory);
            setSelectedInventory(inventoryId);
        }
    };

    const handleBackClick = () => {
        setSelectedInventory(null);
        setInventoryDetails(null);
    };

    return (
        <div className="container">
            {selectedInventory ? (
                <div>
                    <button onClick={handleBackClick} className="btn btn-secondary mb-3">Назад</button>
                    <h5>Детали инвентаризации</h5>
                    <p><strong>Проект:</strong> {inventoryDetails.project_name}</p>
                    <p><strong>Дата:</strong> {inventoryDetails.created_at}</p>
                    <h5>Расхождения</h5>
                    <ul>
                        {inventoryDetails.discrepancies.length > 0 ? (
                            inventoryDetails.discrepancies.map((discrepancy, index) => (
                                <li key={index} style={{ color: '#fff' }}>
                                    {discrepancy.component_name}: Ожидается {discrepancy.expected_quantity}, Фактически {discrepancy.actual_quantity} (Разница: {discrepancy.discrepancy})
                                </li>
                            ))
                        ) : (
                            <li style={{ color: '#fff' }}>Нет расхождений</li>
                        )}
                    </ul>
                </div>
            ) : (
                <div>
                    <h4>Создать инвентаризацию</h4>
                    <form onSubmit={handleFormSubmit} className="mb-4">
                        <div className="form-group" style={{ maxWidth: '400px' }}>
                            <label htmlFor="project">Проект</label>
                            <select
                                id="project"
                                name="project"
                                className="form-control"
                                value={selectedProject || ""}
                                onChange={(e) => setSelectedProject(e.target.value)}
                            >
                                {projects.map(project => (
                                    <option key={project.id} value={project.id}>
                                        {project.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <button type="submit" className="btn btn-primary mt-3">Создать</button>
                    </form>

                    <button onClick={handleShowCompleted} className="btn btn-secondary mb-3">
                        {showCompleted ? 'Скрыть завершенные инвентаризации' : 'Показать завершенные инвентаризации'}
                    </button>

                    {showCompleted && (
                        <div className="completed-inventories">
                            <h5>Завершенные инвентаризации</h5>
                            <div className="row">
                                {completedInventories.length > 0 ? (
                                    completedInventories.map(inventory => (
                                        <div className="col-md-4 mb-3" key={inventory.id}>
                                            <div className="card text-white" style={{ backgroundColor: '#3232', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.4)' }}>

                                            <div className="card-body" style={{ width: '300px', height: '200px' }}>
                                                <h5 className="card-title" style={{ color: '#fff' }}>{inventory.project_name}</h5>
                                                <p className="card-text" style={{ color: '#fff' }}>
                                                    <strong>Дата:</strong> {inventory.created_at}<br />
                                                    <strong>Пользователи:</strong> {inventory.users.length > 0 ? inventory.users.join(', ') : 'Неизвестно'}
                                                </p>
                                                <button 
                                                    className="btn btn-dark"
                                                    onClick={() => handleInventoryClick(inventory.id)}
                                                    style={{ borderRadius: '5px' }}
                                                >
                                                    Посмотреть
                                                </button>
                                            </div>

                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12">
                                        <p style={{ color: '#fff' }}>Нет завершенных инвентаризаций</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default InventoryForm;
